import c from '@/styles/Row';
import { ClassNameProp, Component, ComponentProps } from '@/types/component';
import { cn } from 'lib/utils/cn';
import { getPropStylesFactory } from 'lib/utils/getPropStylesFactory';

export interface RowFooterProps extends ComponentProps<'footer'> {
  colors?: ClassNameProp<'default'>;
  size?: ClassNameProp<'default'>;
  variant?: ClassNameProp<'default'>;
}

export const RowFooterComponent: Component<RowFooterProps> = ({
  children,
  className,
  colors,
  size,
  variant,
  ...props
}) => {
  const getPropStyles = getPropStylesFactory(c);

  const colorsClassName = getPropStyles('footer_colors', colors, 'default');
  const sizeClassName = getPropStyles('footer_size', size, 'default');
  const variantClassName = getPropStyles('footer_variant', variant, 'default');
  const componentClassName = cn(colorsClassName, sizeClassName, variantClassName, className);

  return (
    <footer className={componentClassName} {...props}>
      {children}
    </footer>
  );
};
